import React from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import { arraysEqual } from 'helpers/utils'
import { getRscObject } from "helpers/rsc";
import { APPARATUS } from "components/sports/gar/helper/GarHelpers";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export const TableExpandedAllAround = React.memo((props) => {
    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
    const gender = getRscObject(mirs_rsc).sex
    const { row } = props;
    let apparatus = (gender === "M") ? APPARATUS.MEN : APPARATUS.WOMEN;
    const discipline = mirs_discipline;
    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    const eslData = row?.extCompetitor
    return (
        <>
            {eslData && <div className="text-wrap text-start mirs-esl">{eslData}</div>}
            <table className="table table-detail">
                <thead>
                    <tr>
                        <th className="w-10 text-end"></th>
                        {gender === 'M'
                            ? (
                                <>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"FX"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"PH"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"SR"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"VT"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"PB"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"HB"} abbr={isMobile} /></th>
                                </>
                            )
                            : (
                                <>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"VT"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"UB"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"BB"} abbr={isMobile} /></th>
                                    <th className="w-10 text-end"><SportCode discipline={discipline} entity='@Apparatus' code={"FX"} abbr={isMobile} /></th>
                                </>
                            )
                        }

                    </tr>
                </thead>
                <tbody>
                    <StatByApparatus data={row} apparatus={apparatus} stat={"DIFFICULTY"} />
                    <StatByApparatus data={row} apparatus={apparatus} stat={"EXECUTION"} />
                    <StatByApparatus data={row} apparatus={apparatus} stat={"PENALTY"} />
                    <ScoreByApparatus data={row} apparatus={apparatus} />
                </tbody>
            </table>
        </>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults)
    )
});

const StatByApparatus = ({ data, apparatus, stat }) => {
    let label = '';
    const extendedResults = data.extendedResults;
    switch (stat) {
        case 'DIFFICULTY':
            label = 'HeaderDifficulty'
            break;
        case 'EXECUTION':
            label = 'HeaderExecution'
            break;
        case 'PENALTY':
            label = 'HeaderPenalty'
            break;
        default:
            label = ''
            break;
    }

    let arrStat = []
    Array.isArray(apparatus) && apparatus.forEach((app) => {
        arrStat.push(
            <td key={"All-Around-" + data?.participantCode + "-" + app + "-" + stat} className="text-end">
                {extendedResults?.find(i => i?.er_code === app)?.extensions?.find(e => e?.ere_code === stat)?.ere_value}
            </td>
        )
    });
    return (<tr><th className="text-start"> <Label data={label} /></th>{arrStat}</tr>)
}

const ScoreByApparatus = ({ data, apparatus }) => {
    const extendedResults = data.extendedResults;

    let arrScore = []
    Array.isArray(apparatus) && apparatus.forEach((app) => {
        arrScore.push(
            <td key={"All-Around-" + data?.participantCode + "-" + app + "-" + 'SCORE'} className="text-end">
                {extendedResults?.find(i => i?.er_code === app)?.er_value}
            </td>
        )
    });
    return (<tr><th className="text-start"> <Label data='HeaderScore' /></th>{arrScore}</tr>)
}

export const TableExpandedAllAroundMobile = React.memo((props) => {

    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
    const gender = getRscObject(mirs_rsc).sex
    const { row } = props;
    let apparatus = (gender === "M") ? APPARATUS.MEN : APPARATUS.WOMEN;
    const discipline = mirs_discipline;
    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    const eslData = row?.extCompetitor


    const extendedResults = row.extendedResults;

    let ArrayTbody = []
    Array.isArray(apparatus) && apparatus.forEach((item) => {
        ArrayTbody.push(
            <tr key={"All-Around-" + row?.participantCode + "-" + item} >
                <th className="w-10 text-start"><SportCode discipline={discipline} entity='@Apparatus' code={item} /></th>
                <td className="w-10 text-end">{extendedResults?.find(i => i?.er_code === item)?.extensions?.find(e => e?.ere_code === "DIFFICULTY")?.ere_value}</td>
                <td className="w-10 text-end">{extendedResults?.find(i => i?.er_code === item)?.extensions?.find(e => e?.ere_code === "EXECUTION")?.ere_value}</td>
                <td className="w-10 text-end">{extendedResults?.find(i => i?.er_code === item)?.extensions?.find(e => e?.ere_code === "PENALTY")?.ere_value}</td>
                <td className="w-10 text-end">{extendedResults?.find(i => i?.er_code === item)?.er_value}</td>
            </tr>

        )
    })


    return (
        <>
            {/** ESL */}
            {eslData && <div className="text-wrap text-start mirs-esl">{eslData}</div>}
            <table className="table table-detail">
                <thead>
                    <tr>
                        <th className="w-10 text-end"></th>
                        <th className="w-10 text-end"><Label data='HeaderDifficulty' /></th>
                        <th className="w-10 text-end"><Label data='HeaderExecution' /></th>
                        <th className="w-10 text-end"><Label data='HeaderPenalty' /></th>
                        <th className="w-10 text-end"><Label data='HeaderScore' /></th>
                    </tr>
                </thead>
                <tbody>
                    {ArrayTbody}

                </tbody>
            </table>
        </>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults)
    )
});




